<div class="container-fluid-page">
  <div class="d-flex page__box p-3 mt-2" style="margin-top: 80px; border-radius: 2px; color: white; font-size: 26px">
    &nbsp;&nbsp;Manage Categories
  </div>
  <div class="profile_details">
    <div class="button" style="
        float: right;
        margin-top: -65px !important;
      ">
      <button class="close" mat-button (click)="onClear()">X</button>
    </div>

    <div class="page__content shadow p-3">
      <form [formGroup]="categoryForm" (ngSubmit)="addCategories()" #myform="ngForm">
        <maat-form-field>
          <div style="width: 90%">
            <input type="file" accept="image/png, image/gif, image/jpeg" formControlName="image" name="image" class="form-control"
              (change)="imageFileSelected($event)" />

            <!-- <mat-error style="font-size: 1rem" *ngIf="
                f['image'].errors &&
                f['image'].errors['required'] &&
                f['image'] &&
                myform.submitted
              ">Image is required.</mat-error> -->
          </div>
        </maat-form-field>

        <mat-form-field class="category-name w-full" appearance="fill" style="margin-top: 10px">
          <mat-label class="name" style="color: black; height: 5px; margin-left: 18px">Name</mat-label>
          <input matInput placeholder="Category name goes here" autocomplete="off" formControlName="categoryName" />
          <!-- -----------------Set Error Messsage -->
          <!-- <div style="font-size: 1rem">
            <mat-error *ngIf="
                f['categoryName'].errors && f['categoryName'].errors['required']&&
                myform.submitted
              ">Name is required.</mat-error>
          </div> -->
          <!-- ---------------- -->
        </mat-form-field>
        <button mat-raised-button class="btn btnadd videoCategoryBtn" [disable]="disable">
          <!-- (click)="addCategories()" -->
          Add
        </button>
      </form>
      <div class="category-list-section">
        <div class="category-header d-flex w-full">
          <span class="name-label">Category Name</span>
          <div class="priorityAreaHeader">
            <span class="name-label" >Priority</span>
            <mat-icon class="deleteButton delete" (click)="deleteCategories()">delete</mat-icon>
          </div>
        </div>

        <div class="category-content" [ngClass]="categorydatalist?.length > 8 ? 'overflow' : ''">
          <div class="round">
            <!-- {{categorydatalist|json}} -->
            <div *ngFor="let categoriesItems of categorydatalist" class="category-list d-flex w-full">
              <span class="name-label">{{ categoriesItems.categoryName }}</span>

              <div class="priorityArea" [hidden]="categoriesItems.categoryName=='Coconut' || categoriesItems.categoryName=='Others'">
                <select (change)="selectedPriority(categoriesItems.categoryId, $event.target.value)">
                  <option *ngFor="let item of priorityList" [selected]="item.priority==categoriesItems.priority"
                    [value]="item.priority">
                    {{item.priority}}</option>
                </select>
                <mat-checkbox name="list_name" (change)="itemToDelete(categoriesItems, $event)"></mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr style="height: 1px" />
      <div class="button" style="float: right; margin-top: -20px !important">
        <!-- <button mat-raised-button class="btn btncls" (click)="onClear()">Close</button>
          </div> -->
      </div>
    </div>
  </div>
  <style>
    .page__content {
      min-height: calc(56vh - 80px) !important;
      border-radius: 10px;
      margin-top: -2rem;
      background: white;
      color: black;
      font-size: 2rem;
    }

    .container-fluid {
      height: 60%;
      /* margin-top: -1rem; */
    }

    .name {
      height: 10px;
    }
  </style>
</div>